import { c as _c } from "react/compiler-runtime";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RadioButtonGroup } from "../../../../../RadioButton/RadioButtonGroup";
import { Referrals } from "../../../shared/Referrals/Referrals";
import { draftAgreementAction, setVippsAgreement } from "../../../../store/donation/actions";
import { State } from "../../../../store/state";
import { RecurringDonation } from "../../../../types/Enums";
import { SubmitButton } from "../../../shared/Buttons/NavigationButtons";
import { ErrorField } from "../../../shared/Error/ErrorField";
import { CenterDiv, Pane, PaneContainer, PaneTitle } from "../../Panes.style";
import { VippsDatePicker } from "./VippsDatePicker/VippsDatePicker";
import { VippsButtonWrapper } from "./VippsPane.style";
import { VippsPaymentMethod, WidgetPane3ReferralsProps } from "../../../../types/WidgetProps";
import { usePlausible } from "next-plausible";
import { Dispatch } from "@reduxjs/toolkit";
import { DonationActionTypes } from "../../../../store/donation/types";
import { Action } from "typescript-fsa";
export const VippsPane: React.FC<{
  referrals: WidgetPane3ReferralsProps;
  config: VippsPaymentMethod;
}> = t0 => {
  const $ = _c(21);
  const {
    referrals,
    config
  } = t0;
  const dispatch = useDispatch();
  const donationState = useSelector(_temp);
  const {
    paymentProviderURL,
    recurring,
    vippsAgreement
  } = donationState;
  const [draftError] = useState(false);
  const [chooseChargeDay, setChooseChargeDay] = useState(0);
  const plausible = usePlausible();
  let t1;
  if ($[0] !== chooseChargeDay || $[1] !== config || $[2] !== dispatch || $[3] !== draftError || $[4] !== plausible || $[5] !== recurring || $[6] !== vippsAgreement) {
    t1 = recurring === RecurringDonation.RECURRING && <><div><PaneTitle>{config.recurring_title}</PaneTitle><div style={{
          paddingTop: 20,
          marginBottom: 30
        }}><RadioButtonGroup options={[{
            title: config.recurring_selector_earliest_text,
            value: 0
          }, {
            title: config.recurring_selector_choose_date_text,
            value: 1
          }]} selected={chooseChargeDay} onSelect={option => {
            setChooseChargeDay(option);
            if (vippsAgreement) {
              dispatch(setVippsAgreement({
                ...vippsAgreement,
                initialCharge: option === 0
              }));
            }
          }} /></div>{chooseChargeDay === 1 && <VippsDatePicker config={config.recurring_selector_date_picker_configuration} />}{draftError && <ErrorField text={"Det har skjedd en feil, vennligst pr\xF8v p\xE5 nytt"} />}</div><CenterDiv><div data-cy="vipps-recurring-button" style={{
          marginBottom: 30
        }}><SubmitButton onClick={async () => {
            if (recurring === RecurringDonation.RECURRING) {
              plausible("DraftVippsRecurringAgreement");
              dispatch(draftAgreementAction.started(undefined));
            }
            (document.activeElement as HTMLElement).blur();
          }}>{config.recurring_button_text}</SubmitButton></div></CenterDiv></>;
    $[0] = chooseChargeDay;
    $[1] = config;
    $[2] = dispatch;
    $[3] = draftError;
    $[4] = plausible;
    $[5] = recurring;
    $[6] = vippsAgreement;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  let t2;
  if ($[8] !== config || $[9] !== paymentProviderURL || $[10] !== plausible || $[11] !== recurring) {
    t2 = recurring === RecurringDonation.NON_RECURRING && <><div><PaneTitle>{config.single_title}</PaneTitle></div><CenterDiv><VippsButtonWrapper data-cy="vipps-single-button"><SubmitButton onClick={async () => {
            plausible("InitiateSingleVippsPayment");
            if (recurring === RecurringDonation.NON_RECURRING && paymentProviderURL) {
              window.location.href = paymentProviderURL;
            }
            (document.activeElement as HTMLElement).blur();
          }}>{config.single_button_text}</SubmitButton></VippsButtonWrapper></CenterDiv></>;
    $[8] = config;
    $[9] = paymentProviderURL;
    $[10] = plausible;
    $[11] = recurring;
    $[12] = t2;
  } else {
    t2 = $[12];
  }
  let t3;
  if ($[13] !== referrals.other_referral_input_placeholder || $[14] !== referrals.referrals_title || $[15] !== referrals.show_referrals) {
    t3 = !(referrals.show_referrals === false) && <Referrals text={{
      referrals_title: referrals.referrals_title,
      other_referral_input_placeholder: referrals.other_referral_input_placeholder
    }} />;
    $[13] = referrals.other_referral_input_placeholder;
    $[14] = referrals.referrals_title;
    $[15] = referrals.show_referrals;
    $[16] = t3;
  } else {
    t3 = $[16];
  }
  let t4;
  if ($[17] !== t1 || $[18] !== t2 || $[19] !== t3) {
    t4 = <Pane><PaneContainer>{t1}{t2}{t3}</PaneContainer></Pane>;
    $[17] = t1;
    $[18] = t2;
    $[19] = t3;
    $[20] = t4;
  } else {
    t4 = $[20];
  }
  return t4;
};
function _temp(state) {
  return state.donation;
}